import { Box } from '@mui/material'

const styles = {
  logo: {
    backgroundColor: '#51247A',
    color: 'white',
    display: 'inline-block',
    fontSize: 24,
    fontWeight: 'normal',
    lineHeight: '60px',
    padding: 1,
    mt: 1,
  },
}

export const EspaceLogo = () => {
  return <Box sx={styles.logo}>UQ eSpace</Box>
}
